import { WebLayout } from 'components/Layout';
import { CartLineItem } from '../components/CartLineItem';
import { useCart } from 'context/CartContext';
import { CartIcon } from 'components/icons/CartIcon';
import { formatUGX } from '../api/getProducts';

export function Cart() {
  const { items, subtotal, clearCart } = useCart();

  return (
    <WebLayout>
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-8">
        <div className="mb-10 text-center">
          <div className="mb-3 text-xs font-extrabold uppercase tracking-[0.2em] text-accent">
            Your cart
          </div>
          <h1 className="text-[clamp(1.8rem,4vw,2.5rem)] font-black tracking-tight">
            Items you&apos;ve requested
          </h1>
          <p className="mt-2 text-sm text-text-muted">
            Review your items, then continue to choose how you&apos;d like to pay.
          </p>
        </div>

        {items.length === 0 ? (
          <EmptyCart />
        ) : (
          <>
            <div className="rounded-2xl border border-white/10 bg-card px-5">
              {items.map((item) => (
                <CartLineItem key={item.id} item={item} />
              ))}
            </div>

            <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-white/10 bg-card p-5">
              <div className="flex items-center justify-between text-sm text-text-muted">
                <span>Subtotal</span>
                <span className="text-base font-extrabold text-text">
                  UGX {formatUGX(subtotal)}
                </span>
              </div>
              <p className="text-xs text-text-dim">
                Delivery fee is arranged on WhatsApp based on your location. Discount codes can be
                applied on the next step.
              </p>

              <div className="flex flex-col gap-3 sm:flex-row">
                <a
                  href="/payment"
                  className="flex-1 rounded-full bg-accent py-3 text-center text-sm font-extrabold text-black transition-all hover:-translate-y-0.5 hover:bg-accent-dim"
                >
                  Continue to payment
                </a>
                <button
                  type="button"
                  onClick={clearCart}
                  className="rounded-full border border-white/10 px-5 py-3 text-sm font-bold text-text-muted transition-colors hover:border-white/20 hover:text-text"
                >
                  Clear cart
                </button>
              </div>
            </div>
          </>
        )}
      </section>
    </WebLayout>
  );
}

function EmptyCart() {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-white/10 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-dim text-accent">
        <CartIcon className="h-6 w-6" />
      </span>
      <p className="text-text-muted">Your cart is empty.</p>
      <a
        href="/shop"
        className="rounded-full bg-accent px-6 py-2.5 text-sm font-extrabold text-black transition-all hover:-translate-y-0.5 hover:bg-accent-dim"
      >
        Browse the catalog
      </a>
    </div>
  );
}
